import posthog from 'posthog-js'

export const posthogKey = import.meta.env.VITE_POSTHOG_KEY || 'phc_mhTPDaHPDGSTPwjt0l409pxwIuRTmOWjiviW7XqfHpU';

export function usePostHog() {
    posthog.init(posthogKey, {
        api_host: 'https://us.i.posthog.com',
        defaults: '2025-05-24'
    });

    return { posthog };
}